<template>
  <teleport to="body">
    <transition name="fade">
      <div v-if="show" class="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
        <div class="bg-white rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[80vh] overflow-auto">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-semibold text-gray-900">
              Update Results
            </h2>
            <button class="text-gray-400 hover:text-gray-600" @click="$emit('close')">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div v-if="results">
            <p class="text-gray-700 mb-4">
              {{ results.message }}
            </p>

            <!-- Updated Programs -->
            <div v-if="results.data?.updated?.length" class="mb-6">
              <h3 class="text-lg font-medium text-green-800 mb-3">
                ✅ Updated Programs ({{ results.data.updated.length }})
              </h3>
              <div class="space-y-2 max-h-60 overflow-y-auto">
                <div
                  v-for="program in results.data.updated"
                  :key="program.id"
                  class="bg-green-50 border border-green-200 rounded p-3"
                >
                  <div class="font-medium text-green-900">
                    {{ program.name }}
                  </div>
                  <div class="text-sm text-green-700">
                    Version: {{ program.oldVersion }} → <span class="font-medium">{{ program.newVersion }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Skipped Programs (Already up-to-date) -->
            <div v-if="results.data?.skipped?.length" class="mb-6">
              <h3 class="text-lg font-medium text-blue-800 mb-3">
                ℹ️ Already Up-to-date ({{ results.data.skipped.length }})
              </h3>
              <div class="space-y-2 max-h-40 overflow-y-auto">
                <div
                  v-for="program in results.data.skipped"
                  :key="program.id"
                  class="bg-blue-50 border border-blue-200 rounded p-3"
                >
                  <div class="font-medium text-blue-900">
                    {{ program.name }}
                  </div>
                  <div class="text-sm text-blue-700">
                    Current version: <span class="font-medium">{{ program.version }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Not Found Programs -->
            <div v-if="results.data?.notFound?.length" class="mb-6">
              <h3 class="text-lg font-medium text-orange-800 mb-3">
                ⚠️ Not Found ({{ results.data.notFound.length }})
              </h3>
              <div class="space-y-2 max-h-40 overflow-y-auto">
                <div
                  v-for="automationAppId in results.data.notFound"
                  :key="automationAppId"
                  class="bg-orange-50 border border-orange-200 rounded p-2"
                >
                  <div class="text-sm text-orange-700">
                    Automation App ID: {{ automationAppId }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Summary -->
            <div class="bg-gray-50 rounded p-4">
              <h3 class="text-lg font-medium text-gray-800 mb-2">
                📊 Summary
              </h3>
              <div class="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <span class="text-gray-600">Total Parsed:</span>
                  <span class="font-medium ml-1">{{ results.data?.totalParsed || 0 }}</span>
                </div>
                <div>
                  <span class="text-gray-600">Updated:</span>
                  <span class="font-medium ml-1 text-green-600">{{ results.data?.updated?.length || 0 }}</span>
                </div>
                <div>
                  <span class="text-gray-600">Already Up-to-date:</span>
                  <span class="font-medium ml-1 text-blue-600">{{ results.data?.skipped?.length || 0 }}</span>
                </div>
                <div>
                  <span class="text-gray-600">Not Found:</span>
                  <span class="font-medium ml-1 text-orange-600">{{ results.data?.notFound?.length || 0 }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="flex justify-end mt-6">
            <button class="btn-primary" @click="$emit('close')">
              Close
            </button>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup>
defineProps({
  show: {
    type: Boolean,
    required: true
  },
  results: {
    type: Object,
    default: null
  }
});

defineEmits([ 'close' ]);
</script>
